import {Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  imports: [DocumentViewerPageComponent, NgIf]
})
export class ContractComponent implements OnInit {
  contractUrl = '';
  private sub?: Subscription;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.sub = this.route.queryParamMap.subscribe((params) => {
      this.contractUrl = params.get('url') ?? '';
      console.log('Contract url (queryParam):', this.contractUrl);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
